var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-ID.88923741.png","uri@2x": __webpack_public_path__ + "icon-ID.f4f04074.png","uri@3x": __webpack_public_path__ + "icon-ID.3484d6e3.png",
    width: 19,
    height: 22
});